/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityScreenerSettingsEntry } from './FacilityScreenerSettingsEntry';
import {
    FacilityScreenerSettingsEntryFromJSON,
    FacilityScreenerSettingsEntryFromJSONTyped,
    FacilityScreenerSettingsEntryToJSON,
} from './FacilityScreenerSettingsEntry';

/**
 * 
 * @export
 * @interface GetFacilityScreenerSettings200Response
 */
export interface GetFacilityScreenerSettings200Response {
    /**
     * 
     * @type {Array<FacilityScreenerSettingsEntry>}
     * @memberof GetFacilityScreenerSettings200Response
     */
    data: Array<FacilityScreenerSettingsEntry>;
}

/**
 * Check if a given object implements the GetFacilityScreenerSettings200Response interface.
 */
export function instanceOfGetFacilityScreenerSettings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetFacilityScreenerSettings200ResponseFromJSON(json: any): GetFacilityScreenerSettings200Response {
    return GetFacilityScreenerSettings200ResponseFromJSONTyped(json, false);
}

export function GetFacilityScreenerSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityScreenerSettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FacilityScreenerSettingsEntryFromJSON)),
    };
}

export function GetFacilityScreenerSettings200ResponseToJSON(value?: GetFacilityScreenerSettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FacilityScreenerSettingsEntryToJSON)),
    };
}

